import type { ScheduledItem } from '../../../shared/api/scheduler.api';

/**
 * Очередь отложенных: впереди — ожидающие и публикуемые сейчас, по времени
 * выхода (ближайшее первым); история — вышедшее, упавшее, отменённое, свежее первым.
 */
export function splitQueue(items: readonly ScheduledItem[]): { upcoming: ScheduledItem[]; history: ScheduledItem[] } {
  const t = (i: ScheduledItem) => new Date(i.run_at).getTime();
  const upcoming = items.filter((i) => i.status === 'pending' || i.status === 'running').sort((a, b) => t(a) - t(b));
  const history = items.filter((i) => i.status !== 'pending' && i.status !== 'running').sort((a, b) => t(b) - t(a));
  return { upcoming, history };
}
